import {Injectable} from '@angular/core';
import {Apollo, Mutation} from 'apollo-angular';
import { BehaviorSubject } from 'rxjs';
import gql from 'graphql-tag';
import {take, tap} from 'rxjs/operators';
import { APIResponse, Dataresponse, EmbarcacionConcesion } from '@app/types/types';

const QUERY = gql `
{
  listaDeConcesiones(keyword:"",pageSize:0, pageIndex: 0){
    total
    raResoluembs{
      embarcacionNic
      		reEmbarcaci{
          nombre
          patentes{
          patNumero
      }
    }
      personaDocumento
      rembFechaIni
      rembFechaFin
      rembUsuaregistraAudi

    }
  }
}
`;

@Injectable({
    providedIn: 'root'
})
export class DataResService {

    private listaDeConcesionesSubject = new BehaviorSubject<EmbarcacionConcesion[]>(null);
    listaDeConcesiones$ = this.listaDeConcesionesSubject.asObservable();
    
    
    constructor(private apollo: Apollo){
        this.getDataAPI();
    }

     private getDataAPI():void{
        this.apollo.watchQuery<any> ({
            query: QUERY
        }).valueChanges.pipe(
            take(1),
            tap(({data}) => {
                const {listaDeConcesiones} = data;
                this.listaDeConcesionesSubject.next(listaDeConcesiones.raResoluembs);
            })
        ).subscribe();
    }

}

@Injectable({
  providedIn: 'root'
})
export class ActivarConcesionGQL extends Mutation {
  document = gql`
           mutation activarConcesion(
                   $parametroNic: String!,
                   $concesionNit: String!

             ) {
               activarConcesion(
                parametroNic: $parametroNic,
                concesionNit: $concesionNit
               )
             }`;
}
@Injectable({
  providedIn: 'root'
})

export class DesActivarConcesionGQL extends Mutation {
  document = gql`
           mutation desactivarConcesion(
                   $parametroNic: String!,
                   $concesionNit: String!

             ) {
               desactivarConcesion(
                parametroNic: $parametroNic,
                concesionNit: $concesionNit
               )
             }`;
}